import { cardSurface } from '@/components/atoms/Card';
import { Disclosure } from '@/components/molecules/Disclosure';

import styles from './RawJson.module.scss';

interface RawJsonProps {
    summary: string;
    value: Record<string, unknown>;
}

/** Closed until asked for, as the Cages page's bioscope history is. */
export default function RawJson({ summary, value }: RawJsonProps) {
    return (
        <Disclosure
            variant="inline"
            spacing="none"
            title={summary}
            triggerClassName={styles.summary}>
            <pre {...cardSurface({ variant: 'subtle', radius: 'sm', padding: 'xs' }, styles.json)}>
                {JSON.stringify(value, null, 2)}
            </pre>
        </Disclosure>
    );
}
